export default "__VITE_ASSET__CzuYs$Yw__"